/**
 * Fond des EN-TÊTES DE SECTION de la fiche (« Statut », « Identité »…) : UN
 * identifiant choisi par l'exploitant dans une liste fermée.
 *
 *   * « sans-fond » (le rendu d'origine) : le titre posé sur la feuille ;
 *   * « fond-vue » : une bande derrière le titre, dans la teinte de FOND de la
 *     vue d'où la fiche est ouverte (`reglages.fond`, `components/vues/
 *     fonds.ts`) — blanche, comme la feuille, si la vue n'en a pas.
 *
 * Comme `entete.ts`, ce réglage ne produit AUCUNE feuille de style : la teinte
 * dépend de la VUE ouverte, que seule la fiche connaît. `FicheRecord.vue` lit
 * `sectionsAppliquees` et pose la classe et la teinte elle-même.
 *
 * Fonctions PURES. Aucune valeur reçue ne produit du code : seul
 * l'identifiant voyage.
 */

/**
 * Modèles proposés. MIROIR de `STYLES_SECTIONS` (backend
 * `core/apparence/schemas.ts`) et de la migration 0065 — un test backend fige
 * les trois.
 */
export const STYLES_SECTIONS = ['sans-fond', 'fond-vue'] as const
export type StyleSections = (typeof STYLES_SECTIONS)[number]

export interface SectionsPlateforme {
  style?: StyleSections
}

/** Le rendu d'origine : titre sans bande, comme sans aucun réglage. */
export const DEFAUT_STYLE_SECTIONS: StyleSections = 'sans-fond'

export function estStyleSections(valeur: unknown): valeur is StyleSections {
  return typeof valeur === 'string' && (STYLES_SECTIONS as readonly string[]).includes(valeur)
}

/** Valide une forme reçue et la recopie, ou `null` si UN élément est hors contrat. */
export function normaliserSections(brut: unknown): SectionsPlateforme | null {
  if (typeof brut !== 'object' || brut === null || Array.isArray(brut)) return null
  const resultat: SectionsPlateforme = {}
  for (const [cle, valeur] of Object.entries(brut)) {
    if (cle !== 'style' || !estStyleSections(valeur)) return null
    resultat.style = valeur
  }
  return resultat
}
